/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react';
import * as THREE from 'three';
import { delModel, extrudeSettings, roofPattern, textureAnisotropy, wainscotTrimModel } from '../../../../../../utils/Functions';
import { const_var, params } from '../../../../../../redux/reducers/reducer';
import { CSG } from '../../../../../../assets/libs/csg-lib';
import { NormalStripeImg } from '../../../../../../utils/Textures';
import { useLoader, useThree } from '@react-three/fiber';
import { controls } from '../../../../../../redux/reducers/eventReducer';

const OutsideWallModel = () => {

    const [wallHeight, setWallHeight] = useState(params.p_h);

    const offsetWithDoorThickness = 0.145

    const wainscotColor = useMemo(() => (params.p_w_c_c.replace("0x","#")), [params.p_w_c_c])
    const { gl } = useThree();
    // const texture = const_var.wallTextureObj[params.wallTexture]
        
    const wallModel = useMemo(() => {
        let model = new THREE.Shape();

        model.moveTo(-(params.p_d / 2 + offsetWithDoorThickness), wallHeight - 0.02);
        model.lineTo(params.p_d / 2 + offsetWithDoorThickness, wallHeight - 0.02);
        model.lineTo(params.p_d / 2 + offsetWithDoorThickness, 0.01);
        model.lineTo(-(params.p_d / 2 + offsetWithDoorThickness), 0.01);
        model.closePath()

        return model;
    
    }, [params.p_d, wallHeight, params.p_w_c_n])

    const mainWallModel = useMemo(() => {
        /************** cutting hole using CSG ***************/
        let verticalHorizontalPos = params.p_v_w == true ? {"x":params.p_w / -2 + parseInt(params.cB_addStorage_left) + 0.005,"y": (params.p_w_c_n ? 2.935 : 0), "z":params.p_d / -2 - offsetWithDoorThickness} : {"x": params.p_w / -2 + parseInt(params.cB_addStorage_left) + 0.005,"y" : (params.p_w_c_n ? 2.935 : 0), "z" : params.p_d / 2 + offsetWithDoorThickness}
        let verticalHorizontalRot = params.p_v_w == true ? {"x":Math.PI / -2,"y" : 0,"z" : Math.PI / -2} : {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
        let patternLength = params.p_v_w == true ? params.p_d + offsetWithDoorThickness * 2: wallHeight + (params.p_w_c_n ? -2.935 : 0)
        let patternDepth = params.p_v_w == true ? wallHeight + (params.p_w_c_n ? -2.935 : 0) : params.p_d + offsetWithDoorThickness * 2
        
        const meshWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLength), extrudeSettings(patternDepth)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('leftStorageFront', 'wall'), extrudeSettings(1)))
        const meshWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wallModel, extrudeSettings(1)))
        const meshFrontOffsetWithDoorDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('front', 'wall'), extrudeSettings(1)))
        const meshBackOffsetWithDoorDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('back', 'wall'), extrudeSettings(1)))

        let meshWallModel_Temp = meshWallModel.clone();
        meshWallModel_Temp.position.set(verticalHorizontalPos.x,verticalHorizontalPos.y,verticalHorizontalPos.z);
        meshWallModel_Temp.rotation.set(verticalHorizontalRot.x,verticalHorizontalRot.y,verticalHorizontalRot.z);
        meshWallModel_Temp.updateMatrixWorld();

        let meshWallDelModel_Temp = meshWallDelModel.clone();
        meshWallDelModel_Temp.position.set(params.p_w / -2 + parseInt(params.cB_addStorage_left) + 0.5, 0, 0);
        meshWallDelModel_Temp.rotation.set(0,Math.PI / -2,0)
        meshWallDelModel_Temp.updateMatrixWorld();

        let meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(params.p_w / -2 + parseInt(params.cB_addStorage_left) -0.5, 0, 0);
        meshDelModel_Temp.rotation.set(0,Math.PI / 2,0)
        meshDelModel_Temp.updateMatrixWorld();

        let meshFrontOffsetWithDoorDelModel_Temp = meshFrontOffsetWithDoorDelModel.clone();
        meshFrontOffsetWithDoorDelModel_Temp.position.set(0, 0, params.p_d / 2 - 0.05);
        meshFrontOffsetWithDoorDelModel_Temp.updateMatrixWorld()

        let meshBackOffsetWithDoorDelModel_Temp = meshBackOffsetWithDoorDelModel.clone();
        meshBackOffsetWithDoorDelModel_Temp.position.set(0, 0, -(params.p_d / 2 + 0.95));
        meshBackOffsetWithDoorDelModel_Temp.updateMatrixWorld()

        const meshWallModel_CSG = CSG.fromMesh(meshWallModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshWallDelModel_CSG = CSG.fromMesh(meshWallDelModel_Temp);
        const meshFrontOffsetWithDoorDelModel_CSG = CSG.fromMesh(meshFrontOffsetWithDoorDelModel_Temp);
        const meshBackOffsetWithDoorDelModel_CSG = CSG.fromMesh(meshBackOffsetWithDoorDelModel_Temp);

        const wallModel_CSG =  meshWallModel_CSG.subtract(meshDelModel_CSG);
        const meshWallDel_CSG = wallModel_CSG.intersect(meshWallDelModel_CSG);
        const frontWallDel_CSG = meshWallDel_CSG.subtract(meshFrontOffsetWithDoorDelModel_CSG);
        const backWallDel_CSG = frontWallDel_CSG.subtract(meshBackOffsetWithDoorDelModel_CSG);
        const CSGWallModel = CSG.toMesh(backWallDel_CSG,new THREE.Matrix4(),)

        /************** cutting hole in wainscot using CSG ***************/
        let wainscotVerticalHorizontalPos = params.p_v_w == true ? {"x":params.p_w / -2 + parseInt(params.cB_addStorage_left) + 0.005,"y": 0, "z":params.p_d / -2 - offsetWithDoorThickness} : {"x": params.p_w / -2 + parseInt(params.cB_addStorage_left) + 0.005,"y" : 0, "z" : params.p_d / 2 + offsetWithDoorThickness}
        let wainscotVerticalHorizontalRot = params.p_v_w == true ? {"x":Math.PI / -2,"y" : 0,"z" : Math.PI / -2} : {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
        let lengthPattern = (params.p_v_w) ? patternLength : 3
        let depthPattern = (params.p_v_w) ? 3 : patternDepth

        const meshWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPattern), extrudeSettings(depthPattern)))
        let meshWainscotModel_Temp = meshWainscotModel.clone();
        meshWainscotModel_Temp.position.set(wainscotVerticalHorizontalPos.x,wainscotVerticalHorizontalPos.y,wainscotVerticalHorizontalPos.z);
        meshWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRot.x,wainscotVerticalHorizontalRot.y,wainscotVerticalHorizontalRot.z);
        meshWainscotModel_Temp.updateMatrixWorld();

        const meshWainscotModel_CSG = CSG.fromMesh(meshWainscotModel_Temp);

        const wainscotModel_CSG = meshWainscotModel_CSG.subtract(meshDelModel_CSG);
        // const wainscotModelCSG = wainscotModel_CSG.intersect(meshWallDelModel_CSG);
        const wainscotCSG = wainscotModel_CSG.subtract(meshFrontOffsetWithDoorDelModel_CSG);
        const wainscotDelCSG = wainscotCSG.subtract(meshBackOffsetWithDoorDelModel_CSG);
        const CSGWainscotModel = CSG.toMesh(
            wainscotDelCSG,
            new THREE.Matrix4()
        )

        /************** cutting hole in Wainscot Trim using CSG ***************/

        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.p_d + offsetWithDoorThickness * 2)))
        let meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.position.x = params.p_w / -2 + parseInt(params.cB_addStorage_left)
        meshWainscotTrimModel_Temp.position.z = params.p_d / -2 - offsetWithDoorThickness
        meshWainscotTrimModel_Temp.position.y = 3
        meshWainscotTrimModel_Temp.rotation.y = 0
        meshWainscotTrimModel_Temp.updateMatrixWorld();

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);

        const wainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);
        const wainscotTrimModelCSG = wainscotTrimModel_CSG.subtract(meshFrontOffsetWithDoorDelModel_CSG);
        const wainscotTrimDelModelCSG = wainscotTrimModelCSG.subtract(meshBackOffsetWithDoorDelModel_CSG);
        const CSGWainscotTrimModel = CSG.toMesh(
            wainscotTrimDelModelCSG,
            new THREE.Matrix4()
        )
        const cutMesh = CSG.toMesh(
            meshDelModel_CSG,
            new THREE.Matrix4()
        )

        return { 
            wall: CSGWallModel.geometry,
            wainscotWall: CSGWainscotModel.geometry,
            wTrim: CSGWainscotTrimModel.geometry,
            cut: cutMesh.geometry
        }
        /****************************************** *********/
    }, [params.wallTexture,params.p_v_w, params.p_w, params.cB_addStorage_left, params.p_d, wallHeight, wallModel, const_var.newDoorsArray, params.p_w_c_n])

    useMemo(() => {
        let overHeight = 0;
        const height = (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) : params.p_h
        
        if ((parseInt(params.cB_addStorage_left) < params.p_w / 2) || ((params.singleSlope && params.freeStandingSide === "left") || params.freeStandingSide === "right")) {
            if (params.p_r_s === 1) {
                overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + 0.38;
            } else {
                overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
            }
        } else {
            if (params.p_r_s === 1) {
                overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + 0.38;
            } else {
                overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
            }
        }

        setWallHeight(height + overHeight);
    
    }, [params.p_h, params.cB_addStorage_left, params.p_r_s, params.p_r_p, params.p_w, params.singleSlope, params.freeStandingSide])

    const mainColor = useMemo(() => params.p_w_c.replace('0x', '#'), [params.p_w_c]);

    const texture = useMemo(() => {
        let texture = const_var.wallTextureObj[params.wallTexture];
        textureAnisotropy(gl, texture,(params.wallTexture == "board_batten")? 0.7 : 1.3, (params.wallTexture == "lap")? 0.5 : 1.3, Math.PI/-2);
        return texture
    }, [params.p_v_w,params.wallTexture])

    return (
        <group onPointerOver={e => e.stopPropagation()} onPointerDown={e => e.stopPropagation()} onClick={e => e.stopPropagation()} >
            {mainWallModel.wall &&
                <mesh name="c_b_l_s_r_w" geometry={mainWallModel.wall}>
                    <meshStandardMaterial aoMap={texture} aoMapIntensity={params.p_v_w ? 0.6 : (params.wallTexture == "board_batten") ? 1 :  (params.wallTexture == "lap")? 0.6 : 0}  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={(params.p_v_w || params.wallTexture != "none") ? 0 : 0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} needsUpdate={true}/>
                </mesh>
            }
            {params.p_w_c_n === true && params.cB_addStorage_check_left && mainWallModel.wainscotWall &&
                <mesh name="c_b_l_s_r_w_wainscot" geometry={mainWallModel.wainscotWall} position={[0.001, 0, 0]}>
                    <meshStandardMaterial aoMap={texture} aoMapIntensity={params.p_v_w ? 0.6 : (params.wallTexture == "board_batten") ? 1 :  (params.wallTexture == "lap")? 0.6 : 0}  color={wainscotColor} side={THREE.DoubleSide} roughness={0.5} metalness={(params.p_v_w || params.wallTexture != "none") ? 0 : 0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} needsUpdate={true}/>
                </mesh>
            }
            {params.p_w_c_n === true && params.cB_addStorage_check_left && mainWallModel.wTrim &&
                <mesh name="wainscotTrim" geometry={mainWallModel.wTrim} position={[0.001, 0, 0]} rotation={[0, 0, 0]}>
                    <meshStandardMaterial aoMap={texture} aoMapIntensity={params.p_v_w ? 0.6 : 0} color={wainscotColor} side={THREE.DoubleSide} roughness={0.5} metalness={params.p_v_w ? 0.05 : 0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02}/>
                </mesh>
            }
        </group>
    )
}

export default OutsideWallModel